import { canRead, canWrite } from './permissions.js';
import { useAuth } from './useAuth.js';

/** Convenience hook: usePermissions().canWrite('finance'). */
export function usePermissions() {
  const { permissions } = useAuth();
  return {
    permissions,
    canRead: (module) => canRead(permissions, module),
    canWrite: (module) => canWrite(permissions, module),
  };
}
